import gql from 'graphql-tag';

const UPDATE_TASK = gql`
  mutation updateTask($data: TaskUpdateInput!, $where: TaskWhereUniqueInput!) {
    updateTask(data: $data, where: $where) {
      id
      name
      startDate
      dueDate
      assigneeOrg {
        id
        name
      }
      assigneeUser {
        id
        name
      }
      assigneeUsers {
        id
        name
      }
      collaborators {
        id
        name
      }
      followers {
        id
        name
      }
      requestType
      requestSubType
      status
      taskDetails
      channelPartner {
        id
        name
      }
      advertiser {
        id
        name
      }
      attachedFiles {
        id
        name
        url
      }
      attachedImages {
        id
        name
        url
      }
      relatedCampaigns {
        id
      }
      linkUrl
      urgency
    }
  }
`;

export default UPDATE_TASK;
